import React from 'react'
import { DialogContainer } from 'react-md'

const UnpublishDialog = ({ visible, onCancelUnpublish, onConfirmUnpublish }) => (
  <DialogContainer
    portal
    id='unpublish-artworks-dialog'
    title='Are you sure you want to unpublish the selected artworks?'
    visible={visible}
    onHide={onCancelUnpublish}
    actions={[{
      onClick: onCancelUnpublish,
      primary: false,
      label: 'Cancel'
    }, {
      onClick: onConfirmUnpublish,
      primary: true,
      label: 'Confirm'
    }]}
  >
    The selected artworks will be immediately unpublished from the Shopify
    store and moved to the DRAFT status.
  </DialogContainer>
)

export default UnpublishDialog



// WEBPACK FOOTER //
// ./src/containers/Artworks/UnpublishDialog.js